import { hideProgress, showProgress } from 'src/modern/progressSpiner/progressSpiner';

export default function Pagination() {
    console.log('pagination ready');
    const containerList = ['#landlordDirectory', '#property-list-container', '#landlords-list', '#advert-list', "#events-list1", "#events-list2", "#events-list3", "#propertyList"];
    containerList.forEach((item) => {
        initPagination(item);
    });
}

function initPagination(selector) {
    const container = document.querySelector(selector);
    if (!container) return;
    const links = container.querySelectorAll('.PagedList-pager.PagedList-pager--ajax li a');
    const firstLinksCount = container.querySelectorAll('.PagedList-skipToFirst').length;
    if (!links.length) return;
    if (links.length == 4 || firstLinksCount > 1 && links.length == 4 * firstLinksCount) {
        container.querySelectorAll('.PagedList-skipToFirst').forEach((item) => {
            item.classList.add('disabled');
        });
        container.querySelectorAll('.PagedList-skipToFirst a').forEach((item) => {
            item.removeAttribute("href");
        });
        container.querySelectorAll('.PagedList-skipToLast').forEach((item) => {
            item.classList.add('disabled');
        });
        container.querySelectorAll('.PagedList-skipToLast a').forEach((item) => {
            item.removeAttribute("href");
        });
    }
    links.forEach((link) => {
        link.onclick = (event) => {
            event.preventDefault();
            onClickLink.call(this, event, container);
        };
    });
}

function onClickLink(event, container) {
    if (!event.currentTarget.parentElement.classList.contains('disabled')) {
        showProgress();
        fetch(event.target.attributes.href.value, {
            method: 'GET'
        }).then((resp) => resp.text()).then((data) => {
            container.innerHTML = data;
            hideProgress();
            Pagination(); // used because from API return full HTML peace
        }).catch((error) => {
            alert('An Error occurred: ' + error);
        });
    }
}
